import React, {useEffect, useState} from "react";
import FunctionsData from "../../Functions/FunctionsData";
import {Button, FormControl, LinearProgress, TextField} from "@mui/material";
import LandingSoldOutMessageCampaignsCommunity from "../LandingSoldOutMessageCampaignsCommunity";
import LandingSoldOutMessageCampaignsOutreach from "../LandingSoldOutMessageCampaignsOutreach";
import cat from "../../img/cat.png";
import LandingAutoComplete from "../LandingAutoComplete";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCat, faDog} from "@fortawesome/free-solid-svg-icons";

export default function CommunityStep0 ({defaultLogo,setVets, postCode, aStep, setAStep, setStep, setCurrentVet, googlePlace, setGooglePlace, ReactGA, setSponsorId, setSponsorName, sponsorName, setSponsorProgram, sponsorProgram, setSponsorCost, setSponsorMicrochipExtraCost, setSponsorEmailText, setSponsorLogo,accounts,inspectors,outreach, cmpId}) {

    const [show, setShow] = useState(true);
    const [showVets, setShowVets] = useState(false);
    const [vetsRaw, setVetsRaw] = useState([]);
    const [vetsRawLoading, setVetsRawLoading] = useState(false);
    const [selectionVets, setSelectionVets] = useState([]);
    const [showVetsFailure, setShowVetsFailure] = useState(false);
    const [campaignEmpty, setCampaignEmpty] = useState(0);
    const pc = postCode;
    const groupIds = accounts[0].idTokenClaims.groups ? accounts[0].idTokenClaims.groups.join(',') : '';
   
    useEffect(() => {
        setVetsRawLoading(true)
        const endpoint = outreach
        ? '/api/campaign/outreach/vets'
        : '/api/campaign/community/vets';
        FunctionsData.postDataReturn(
            endpoint,
            {
                postcode:postCode,
                lng:googlePlace.X_COORDINATE,
                lat:googlePlace.Y_COORDINATE,
                groups: groupIds,
                campaignId:cmpId
            }
        ).then((r) => {
            try{
                setVetsRaw([...r]);
            }catch(e) {
                setVetsRawLoading(false);
            }
        }).then(() => setVetsRawLoading(false));

    }, [postCode, cmpId]);


    useEffect(() => {

        // setShowVets((vetsRaw.length > 0 && campaignEmpty > 0));

        try {
            setVets(vetsRaw)
            setShowVets((postCode > 0));
            setShow((vetsRaw.length > 0 && campaignEmpty > 0));
            setShowVetsFailure(!(vetsRaw.length > 0) || campaignEmpty === 0);
            (vetsRaw.length > 0 && campaignEmpty > 0) ? setSelectionVets([...vetsRaw]) : setSelectionVets([]);
        } catch (e) {
            console.log(e);
        }

    }, [vetsRaw,campaignEmpty]);

    const ShowFailure = () => {

        if (show === false) return null;
        if (showVetsFailure === false) return null;
        return (
            <div className={"failure-box"}>

                <img src={cat} style={{width: '100%', marginTop: 0, marginBottom: 20}}/>

                <p>
                    Thank you for looking to desex your pet. Currently there are no active Snip'n'Chip campaigns in your
                    area. If you believe you are eligible for a Snip ‘n’ Chip campaign currently happening in your area,
                    please email <a href={"mailto:snipnchip@spca.nz"} target={"_blank"}
                                    onClick={() => window.gtag('event', 'action', {
                                        category: 'User',
                                        action: 'Emailed snipnchip@spca.nz'
                                    })}>snipnchip@spca.nz</a> and we can check this for you.
                    We have compiled some other options that may help you with desexing your animal:
                </p>
                <p>
                    <strong>Compare vet clinic prices:</strong>
                    The cost can vary between vet clinics and we recommend calling around to compare prices. There are
                    some vet clinics across the country that provide low cost desexing, as well as payment plans. Each
                    vet clinic will be able to discuss their individual processes and requirements, and answer any
                    questions you may have. Generally kittens will need to be at least 1kg (approximately 10-12 weeks
                    old) before they can be desexed.
                </p>
                <p>
                    <strong>Look into other services</strong>: Other organisations or social services in
                    your area may be able to offer desexing services or provide financial assistance. Most of these can
                    be found online through Google.
                </p>
                <p>
                    <strong>Check in regularly at 'Help someone desex their pet':</strong> <a
                    href={"https://www.facebook.com/Helpsomeonefixtheirpet/"} target={"_blank"}>Help Someone desex their
                    pet</a> is a great resource page on Facebook that lists desexing options around the country and is
                    updated regularly.
                </p>

                <p>
                    <Button variant={"contained"} style={{marginTop: 20, background: '#00C3B4'}} onClick={() => {
                        setStep(0);
                        window.gtag('event', 'action', {
                            category: 'User',
                            action: 'Clicked start over'
                        });
                    }}>Start over</Button>
                </p>

            </div>
        )
    }

    if (show === true && showVetsFailure === true) return (
        <div className={"form"}>
            <ShowFailure/>
        </div>
    );

    const ShowNextButton = (props) => {

        if (1 === 1 || postCode === 'undefined' || postCode === '' || parseInt(postCode) === 0) return null;
        return (
            <div>
                <Button
                    onClick={() => {
                        setAStep(aStep + 1)
                    }}
                    sx={{margin: 1, width: '100%'}}
                >Next
                </Button>
            </div>
        )
    }

    return (
        <div>
            <div className={"form"}>
                <h3 style={{marginBottom: 20}}>Enter the owner’s address to select a Vet Clinic</h3>
                <FormControl fullWidth sx={{textAlign: 'center'}}>
                    <LandingAutoComplete googlePlace={googlePlace}
                                         setGooglePlace={setGooglePlace}
                                         row={{...googlePlace, formatted_address: googlePlace.address}}
                                         ReactGA={ReactGA}
                                         community
                                         text={"Enter the owner’s address to select a Vet Clinic"}
                    />
                </FormControl>
                <ShowVets {...{postCode,outreach,inspectors,setCampaignEmpty,accounts,selectionVets,setSponsorId, setSponsorName,setSponsorProgram,setSponsorCost,setSponsorMicrochipExtraCost, setSponsorEmailText,setSponsorLogo, defaultLogo,vetsRawLoading,showVets, campaignEmpty, setAStep, aStep,setCurrentVet }} />
                <ShowNextButton postCode={pc}
                                aStep={aStep}
                                setAStep={setAStep}
                                setStep={setStep}
                                ReactGA={ReactGA}
                />
            </div>
            <Button
                onClick={() => {
                    window.gtag('event', 'action', {
                        category: 'User',
                        action: 'Clicked cancel application'
                    });
                    setStep(0)
                }}
                sx={{margin: 1}}
            >Cancel application
            </Button>
        </div>

    )
}


const ShowVets = ({postCode,outreach,inspectors,setCampaignEmpty,accounts,selectionVets,setSponsorId, setSponsorName,setSponsorProgram,setSponsorCost,setSponsorMicrochipExtraCost, setSponsorEmailText,setSponsorLogo, defaultLogo,vetsRawLoading,showVets, campaignEmpty, setAStep, aStep,setCurrentVet }) => {

    const [sponsors, setSponsors] = useState([]);
    const [sponsorsLoading, setSponsorsLoading] = useState(true);
    const [filterVets, setFilterVets] = useState('');
    const [vetFiltered, setVetsFiltered] = useState([]);
    const groupIds = accounts[0].idTokenClaims.groups ? accounts[0].idTokenClaims.groups.join(',') : '';

    useEffect(() => {

        if(postCode !== undefined && postCode > 0 ){
 
            //@todo add sponsor data
            FunctionsData.fetchDataGet(
                '/api/orders/sponsor_community/' + postCode,
                setSponsors,
                sponsorsLoading,
                setSponsorsLoading
            );

            FunctionsData.postDataReturn(
                (
                    outreach
                        ? '/api/campaign/outreach/postcodes/' + postCode
                        : inspectors
                            ? '/api/campaign/inspectors/postcodes/' + postCode
                            : '/api/campaign/community/postcodes/' + postCode
                ),
                {groups:groupIds}
            ).then((r) => {
                console.log(r)
                setCampaignEmpty(r)
            })
        }
 

    }, [postCode])

    useEffect(() => {
        console.log(filterVets,selectionVets)
        if(filterVets !== '') {
            let s = selectionVets.filter(({business_name,email,city,suburb,street}) =>
                String(business_name).toLowerCase().trim().includes(filterVets.toLowerCase().trim()) ||
                String(email).toLowerCase().trim().includes(filterVets.toLowerCase().trim()) ||
                String(city).toLowerCase().trim().includes(filterVets.toLowerCase().trim()) ||
                String(suburb).toLowerCase().trim().includes(filterVets.toLowerCase().trim()) ||
                String(street).toLowerCase().trim().includes(filterVets.toLowerCase().trim())
            )

            for(let x in s) {
                let excl = String(s[x].excluded_animals).split(',') ?? [];
                s[x]['excl'] = excl;
            }

            setVetsFiltered(s)
        }else{
            let s = selectionVets;
            for(let x in s) {
                let excl = String(s[x].excluded_animals).split(',') ?? [];
                s[x]['excl'] = excl;
            }
            setVetsFiltered(selectionVets);
        }

    }, [selectionVets,filterVets]);


    useEffect(() => {

        // console.log('sponsors',sponsors)
        try {
            if (sponsors.id > 0 && sponsors.optout_community === 0) {
                setSponsorId(sponsors.id);
                setSponsorName(sponsors.name);
                setSponsorProgram(sponsors.program);
                setSponsorCost(sponsors.applicant_cost);
                setSponsorMicrochipExtraCost(sponsors.microchip_extra_cost);
                setSponsorEmailText(sponsors.email_text_url);
                setSponsorLogo(sponsors.logo);
            }
        } catch (e) {
            setSponsorId(0);
            setSponsorName('');
            setSponsorProgram('');
            setSponsorCost(0.00);
            setSponsorMicrochipExtraCost(0.00);
            setSponsorEmailText('');
            setSponsorLogo(defaultLogo);
        }

    }, [sponsors])

    // console.log('LandingSoldOutMessageCampaignsCommunity',campaignEmpty,selectionVets)
    if(vetsRawLoading === true) return <LinearProgress style={{margin:'20px 0 '}} />
    if (sponsorsLoading === true) return <LinearProgress style={{margin:'20px 0 '}} />;
    if (showVets === false) return null;
    if ((campaignEmpty === 0 || !campaignEmpty) && !outreach) {
        return <LandingSoldOutMessageCampaignsCommunity/>;
    }
    else if((campaignEmpty === 0 || !campaignEmpty) && outreach){
        return <LandingSoldOutMessageCampaignsOutreach/>;
    }

    if (selectionVets.length === 0 && parseInt(campaignEmpty) > 0) {
        window.gtag('event', 'response', {
            category: 'Eligibility',
            action: 'Address not eligible'
        });
        return (
            <div className={"vet-box"}>
                <h3>No vets for the owner's area available at this time. Please check in later.</h3>
            </div>
        )
    }

    window.gtag('event', 'response', {
        category: 'Eligibility',
        action: 'Address eligible'
    });

	//@todo change the below to have more than cats,dogs
    return (
        <div className={"vet-box"}>
            <div>
                <h3 style={{marginTop: 10}}>Please choose a vet from the list below.</h3>
            </div>
            <div style={{marginBottom:20}}>
                <TextField placeholder={"Filter vets ..."} fullWidth value={filterVets} onChange={(e) => setFilterVets(e.target.value)} />
            </div>
            {vetFiltered.length === 0 ? <>No vets match your query.</> : null}
            {vetFiltered.map((d, index) => {
                if(d['excluded_animals']?.includes('Cat') && d['excluded_animals']?.includes('Dog')) return null;
                return (
                    <div key={d.id} className="vet-detail">

                        <h2 style={{margin:0}}>
                            {d.business_name}
                            {!d['excluded_animals']?.includes('Cat') && <FontAwesomeIcon icon={faCat} style={{marginLeft:10, fontSize:18}} />}
                            {!d['excluded_animals']?.includes('Dog') && <FontAwesomeIcon icon={faDog} style={{marginLeft:10, fontSize:18}} />}
                        </h2>

                        { (
  <small>
    Within {Number(d.distance).toFixed(1)} kilometers.
  </small>
)}
                        <p><strong>{d.street} {d.suburb}</strong></p>
                        <p><strong>{d.city} {d.postcode}</strong></p>
                        <p><b>Email</b>: {d.email} {(d.phone !== '' && d.phone !== '0') ?
                            <span>, <b>Phone</b>: {d.phone}</span> : undefined}</p>
                        {(d.supplier_hours !== '' && 'this' === 'deactivated') ?
                            <p><b>Hours</b>: {d.supplier_hours}</p> : undefined}
                        {(d.supplier_website !== '') ? <p><b>Website</b>: {d.supplier_website}</p> : undefined}
                        {(d.supplier_terms_community !== '') ? <p><b>T&Cs</b>:
                            {d.supplier_terms} &nbsp;
                            {d.supplier_terms_community}</p> : undefined}
                        <Button size="small" onClick={() => {
                            setCurrentVet(d.id);
                            setAStep(aStep + 1);
                            window.gtag('event', 'action', {
                                category: 'User',
                                action: 'Selected vet'
                            });
                        }} variant={"contained"} sx={{marginTop: 1}}>Select this Vet</Button>
                    </div>
                )
            })}
        </div>
    )
}
